import React from "react";
import { useNavigate } from "react-router-dom";

export default function AddUpdateHeader({ list, modal }) {
  const navigate = useNavigate();
  return (
    <div className="">
      <div className=" d-flex justify-content-center flex-column w-100">
        <div className="searchbar d-flex justify-content-between align-items-center">
          <div className="col-md-6 p-0">
            <h4>{modal}</h4>
          </div>
        </div>
      </div>
    </div>
  );
}
